import { Injectable } from '@angular/core';
import * as i18nIsoCountries from 'i18n-iso-countries';

@Injectable({ providedIn: 'root' })
export class CountriesListService {
    public getCountriesList(language: string = 'fr'): i18nIsoCountries.LocalizedCountryNames {
        try {
            i18nIsoCountries.registerLocale(require(`i18n-iso-countries/langs/${language}.json`));
            return i18nIsoCountries.getNames(language);
        } catch {
            // If country names doesn't exist in the selected language then display the english one
            i18nIsoCountries.registerLocale(require(`i18n-iso-countries/langs/en.json`));
            return i18nIsoCountries.getNames('en');
        }
    }
}
